//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required } from 'vuelidate/lib/validators';
import ValidationMixin from '../../common/form/mixins/ValidationMixin';
import TextInput from '../components/textInput.vue';
import ErrorDisplay from '../../common/ErrorDisplay.vue';
import NumberInput from '../components/numberInput.vue';
import GroupCheckboxInput from '../components/groupCheckboxInput.vue';
import SelectInput from '@/components/survey/components/selectInput';

export default {
  name: 'BrooksSurveyInputs',
  components: {
    SelectInput,
    TextInput,
    ErrorDisplay,
    NumberInput,
    GroupCheckboxInput
  },
  mixins: [ValidationMixin],
  props: ['submit'],
  created() {
    // Hardcoding a coupon for now
    this.coupon = 'testBrooks';
    // Leaving this code commented so I can use it when we decide how are we getting the code for the surveys
    //this.coupon = this.$route.params.couponCode || null;
    //this.teamId = this.$route.params.teamId || null;
  },
  data() {
    return {
      loading: false,
      error: null,
      formIsValid: null,
      showCoupon: false,
      coupon: null,
      injuryInLast5Years: false,
      contact: 'Yes',
      injuryRegionOptions: [
        { text: 'Ankle Joint', value: 'Ankle Joint' },
        { text: 'Knee Joint', value: 'Knee Joint' },
        { text: 'Hip Joint', value: 'Hip Joint' },
        { text: 'Lower Back', value: 'Lower Back' },
        { text: 'Upper Leg', value: 'Upper Leg' },
        { text: 'Lower Leg', value: 'Lower Leg' },
        { text: 'Foot', value: 'Foot' },
      ],
      injuryRegions: [],
      injuryOther: null,
      firstName: '',
      lastName: '',
      comments: '',
      teamId: '',
      yearBorn: null,
      sportSelected: [],
      height: null,
      weight: null,
      sex: null,
      motivations: [
        { text: 'To tone, build, or maintain my current physique', value: 'To tone, build, or maintain my current physique' },
        { text: 'My physical health depends on it', value: 'My physical health depends on it' },
        { text: 'To run longer or faster', value: 'To run longer or faster' },
        { text: 'To be outdoors', value: 'To be outdoors' },
        { text: 'To clear my mind', value: 'To clear my mind' },
        { text: 'Stress relief', value: 'Stress relief' },
        { text: 'Working out brings balance to my life', value: 'Working out brings balance to my life' },
      ],
      menOrWomenShoeSize: "Men's",
      shoeSizes: [
        { text: '5', value: '5' },
        { text: '5.5', value: '5.5' },
        { text: '6', value: '6' },
        { text: '6.5', value: '6.5' },
        { text: '7', value: '7' },
        { text: '7.5', value: '7.5' },
        { text: '8', value: '8' },
        { text: '8.5', value: '8.5' },
        { text: '9', value: '9' },
        { text: '9.5', value: '9.5' },
        { text: '10', value: '10' },
        { text: '10.5', value: '10.5' },
        { text: '11', value: '11' },
        { text: '11.5', value: '11.5' },
        { text: '12', value: '12' },
        { text: '12.5', value: '12.5' },
        { text: '13', value: '13' },
        { text: '14', value: '14' },
        { text: '15', value: '15' },
        { text: '16', value: '16' },
      ],
      shoeSize: null,
      mensShoeWidths: [
        { text: 'B – Narrow', value: 'B – Narrow' },
        { text: 'D – Standard', value: 'D – Standard' },
        { text: '2E – Wide', value: '2E – Wide' },
        { text: '4E – Extra Wide', value: '4E – Extra Wide' },
        { text: '6E – 2x Extra Wide', value: '6E – 2x Extra Wide' },
      ],
      womensShoeWidths: [
        { text: 'AA – Narrow', value: 'AA – Narrow' },
        { text: 'B – Standard', value: 'B – Standard' },
        { text: 'D – Wide', value: 'D – Wide' },
        { text: '2E – Extra Wide', value: '2E – Extra Wide' },
        { text: '4E – 2x Extra Wide', value: '4E – 2x Extra Wide' },
      ],
      shoeWidth: null,
      brands: [
        { text: '361 Degrees', value: '361 Degrees' },
        { text: 'adidas', value: 'adidas' },
        { text: 'Altra', value: 'Altra' },
        { text: 'ARC\'TERYX', value: 'ARC\'TERYX' },
        { text: 'ASICS', value: 'ASICS' },
        { text: 'Brooks', value: 'Brooks' },
        { text: 'Columbia', value: 'Columbia' },
        { text: 'HOKA ONE ONE', value: 'HOKA ONE ONE' },
        { text: 'inov-8', value: 'inov-8' },
        { text: 'LaSportiva', value: 'LaSportiva' },
        { text: 'Merrell', value: 'Merrell' },
        { text: 'Mizuno', value: 'Mizuno' },
        { text: 'New Balance', value: 'New Balance' },
        { text: 'Newton', value: 'Newton' },
        { text: 'Nike', value: 'Nike' },
        { text: 'On', value: 'On' },
        { text: 'Puma', value: 'Puma' },
        { text: 'Reebok', value: 'Reebok' },
        { text: 'Salming', value: 'Salming' },
        { text: 'Salomon', value: 'Salomon' },
        { text: 'Saucony', value: 'Saucony' },
        { text: 'Skechers', value: 'Skechers' },
        { text: 'The North Face', value: 'The North Face' },
        { text: 'Topo Athletic', value: 'Topo Athletic' },
        { text: 'Under Armour', value: 'Under Armour' },
        { text: 'Not Listed', value: 'Not Listed' },
      ],
      shoeBrand: null,
      brooksModels: [
        { text: 'Addiction', value: 'Addiction' },
        { text: 'Adrenaline GTS', value: 'Adrenaline GTS' },
        { text: 'Aduro', value: 'Aduro' },
        { text: 'Anthem', value: 'Anthem' },
        { text: 'Ariel', value: 'Ariel' },
        { text: 'Beast', value: 'Beast' },
        { text: 'Bedlam/Levitate GTS', value: 'Bedlam/Levitate GTS' },
        { text: 'Caldera', value: 'Caldera' },
        { text: 'Cascadia', value: 'Cascadia' },
        { text: 'Defyance', value: 'Defyance' },
        { text: 'Dyad', value: 'Dyad' },
        { text: 'Ghost', value: 'Ghost' },
        { text: 'Glycerin', value: 'Glycerin' },
        { text: 'Hyperion', value: 'Hyperion' },
        { text: 'Hyperion Elite', value: 'Hyperion Elite' },
        { text: 'Hyperion Tempo', value: 'Hyperion Tempo' },
        { text: 'Launch', value: 'Launch' },
        { text: 'Levitate', value: 'Levitate' },
        { text: 'PureCadence', value: 'PureCadence' },
        { text: 'PureConnect', value: 'PureConnect' },
        { text: 'PureFlow', value: 'PureFlow' },
        { text: 'PureGrit', value: 'PureGrit' },
        { text: 'Range', value: 'Range' },
        { text: 'Ravenna/Launch GTS', value: 'Ravenna/Launch GTS' },
        { text: 'Revel', value: 'Revel' },
        { text: 'Ricochet', value: 'Ricochet' },
        { text: 'Signal', value: 'Signal' },
        { text: 'Trace', value: 'Trace' },
        { text: 'Transcend/Glycerin GTS', value: 'Transcend/Glycerin GTS' },
        { text: 'Transmit', value: 'Transmit' },
        { text: 'Not Listed', value: 'Not Listed' },
      ],
      nikeModels: [
        { text: 'Air Max Sequent', value: 'Air Max Sequent' },
        { text: 'Air VaporMax Flyknit', value: 'Air VaporMax Flyknit' },
        { text: 'Air VaporMax', value: 'Air VaporMax' },
        { text: 'Air Zoom Tempo NEXT%', value: 'Air Zoom Tempo NEXT%' },
        { text: 'Epic React Flyknit', value: 'Epic React Flyknit' },
        { text: 'Free Run', value: 'Free Run' },
        { text: 'Free Run Flyknit', value: 'Free Run Flyknit' },
        { text: 'Joyride', value: 'Joyride' },
        { text: 'Legend React', value: 'Legend React' },
        { text: 'Odyssey React', value: 'Odyssey React' },
        { text: 'Pegasus', value: 'Pegasus' },
        { text: 'Pegasus Turbo', value: 'Pegasus Turbo' },
        { text: 'React Infinity', value: 'React Infinity' },
        { text: 'React Miler', value: 'React Miler' },
        { text: 'Structure', value: 'Structure' },
        { text: 'Vaporfly 4%', value: 'Vaporfly 4%' },
        { text: 'Vaporfly NEXT%', value: 'Vaporfly NEXT%' },
        { text: 'Vomero', value: 'Vomero' },
        { text: 'Zoom Fly', value: 'Zoom Fly' },
        { text: 'Zoom Winflo', value: 'Zoom Winflo' },
        { text: 'Not Listed', value: 'Not Listed' },
      ],
      adidasModels: [
        { text: 'Adizero Adios Pro', value: 'Adizero Adios Pro' },
        { text: 'Adizero Pro', value: 'Adizero Pro' },
        { text: 'Alphabounce Beyond', value: 'Alphabounce Beyond' },
        { text: 'Alphabounce Instinct', value: 'Alphabounce Instinct' },
        { text: 'Boston', value: 'Boston' },
        { text: 'PUREBOOST', value: 'PUREBOOST' },
        { text: 'PUREBOOST GO', value: 'PUREBOOST GO' },
        { text: 'SOLAR GLIDE', value: 'SOLAR GLIDE' },
        { text: 'ULTRABOOST', value: 'ULTRABOOST' },
        { text: 'ULTRABOOST Clima', value: 'ULTRABOOST Clima' },
        { text: 'ULTRABOOST Low', value: 'ULTRABOOST Low' },
        { text: 'ULTRABOOST Parley', value: 'ULTRABOOST Parley' },
        { text: 'Not Listed', value: 'Not Listed' },
      ],
      asicsModels: [
        { text: 'Gel Cumulus', value: 'Gel Cumulus' },
        { text: 'Gel DS Trainer', value: 'Gel DS Trainer' },
        { text: 'Gel Kayano', value: 'Gel Kayano' },
        { text: 'Gel Kayano Lite', value: 'Gel Kayano Lite' },
        { text: 'Gel Nimbus', value: 'Gel Nimbus' },
        { text: 'Gel Nimbus Lite', value: 'Gel Nimbus Lite' },
        { text: 'Gel Quantum', value: 'Gel Quantum' },
        { text: 'GlideRide', value: 'GlideRide' },
        { text: 'GT 1000', value: 'GT 1000' },
        { text: 'GT 2000', value: 'GT 2000' },
        { text: 'Metaracer', value: 'Metaracer' },
        { text: 'Novablast', value: 'Novablast' },
        { text: 'Not Listed', value: 'Not Listed' },
      ],
      newBalanceModels: [
        { text: '860', value: '860' },
        { text: '880', value: '880' },
        { text: '990', value: '990' },
        { text: '1080', value: '1080' },
        { text: 'Fresh Foam Beacon', value: 'Fresh Foam Beacon' },
        { text: 'Fresh Foam More', value: 'Fresh Foam More' },
        { text: 'Fresh Foam Vongo', value: 'Fresh Foam Vongo' },
        { text: 'Fresh Foam Zante', value: 'Fresh Foam Zante' },
        { text: 'FuelCell Prism', value: 'FuelCell Prism' },
        { text: 'FuelCell RC Elite', value: 'FuelCell RC Elite' },
        { text: 'FuelCell TC', value: 'FuelCell TC' },
        { text: 'Minimus Trail', value: 'Minimus Trail' },
        { text: 'Not Listed', value: 'Not Listed' },
      ],
      hokaModels: [
        { text: 'Arahi', value: 'Arahi' },
        { text: 'Bondi', value: 'Bondi' },
        { text: 'Carbon X', value: 'Carbon X' },
        { text: 'Cavu', value: 'Cavu' },
        { text: 'Challenger', value: 'Challenger' },
        { text: 'Clifton', value: 'Clifton' },
        { text: 'Gaviota', value: 'Gaviota' },
        { text: 'Hupana', value: 'Hupana' },
        { text: 'Rincon', value: 'Rincon' },
        { text: 'Rocket X', value: 'Rocket X' },
        { text: 'Speedgoat', value: 'Speedgoat' },
        { text: 'Stinson ATR', value: 'Stinson ATR' },
        { text: 'Torrent', value: 'Torrent' },
        { text: 'Not Listed', value: 'Not Listed' },
      ],
      mizunoModels: [
        { text: 'Wave Catalyst', value: 'Wave Catalyst' },
        { text: 'Wave Creation', value: 'Wave Creation' },
        { text: 'Wave Horizon', value: 'Wave Horizon' },
        { text: 'Wave Inspire', value: 'Wave Inspire' },
        { text: 'Wave Knit', value: 'Wave Knit' },
        { text: 'Wave Prophecy', value: 'Wave Prophecy' },
        { text: 'Wave Rider', value: 'Wave Rider' },
        { text: 'Wave Shadow', value: 'Wave Shadow' },
        { text: 'Wave Sky', value: 'Wave Sky' },
        { text: 'Wave Sonic', value: 'Wave Sonic' },
        { text: 'Not Listed', value: 'Not Listed' },
      ],
      onModels: [
        { text: 'Cloud', value: 'Cloud' },
        { text: 'Cloudace', value: 'Cloudace' },
        { text: 'Cloudbloom', value: 'Cloudbloom' },
        { text: 'Cloudflash', value: 'Cloudflash' },
        { text: 'Cloudflow', value: 'Cloudflow' },
        { text: 'Cloudflyer', value: 'Cloudflyer' },
        { text: 'Cloudstratus', value: 'Cloudstratus' },
        { text: 'Cloudsurfer', value: 'Cloudsurfer' },
        { text: 'Cloudswift', value: 'Cloudswift' },
        { text: 'Cloudventure', value: 'Cloudventure' },
        { text: 'Not Listed', value: 'Not Listed' },
      ],
      sauconyModels: [
        { text: 'Endorphin Pro', value: 'Endorphin Pro' },
        { text: 'Endorphin Shift', value: 'Endorphin Shift' },
        { text: 'Endorphin Speed', value: 'Endorphin Speed' },
        { text: 'Freedom', value: 'Freedom' },
        { text: 'Guide', value: 'Guide' },
        { text: 'Hurricane', value: 'Hurricane' },
        { text: 'Kinvara', value: 'Kinvara' },
        { text: 'Liberty', value: 'Liberty' },
        { text: 'Omni', value: 'Omni' },
        { text: 'Peregrine', value: 'Peregrine' },
        { text: 'Redeemer', value: 'Redeemer' },
        { text: 'Ride', value: 'Ride' },
        { text: 'Triumph', value: 'Triumph' },
        { text: 'Not Listed', value: 'Not Listed' },
      ],
      altraModels: [
        { text: 'Escalante', value: 'Escalante' },
        { text: 'Lone Peak', value: 'Lone Peak' },
        { text: 'Olympus', value: 'Olympus' },
        { text: 'Paradigm', value: 'Paradigm' },
        { text: 'Provision', value: 'Provision' },
        { text: 'Torin', value: 'Torin' },
        { text: 'Not Listed', value: 'Not Listed' },
      ],
      shoeModel: null,
      modelText: null,
      motivation: null,
    };
  },
  computed: {
    showBrandTextInput() {
      return this.shoeModel === 'Not Listed' || (this.shoeBrand !== null && !['Brooks', 'Nike', 'adidas', 'ASICS', 'New Balance', 'HOKA ONE ONE', 'Mizuno', 'On', 'Saucony', 'Altra'].includes(this.shoeBrand));
    },
    showShoeModel() {
      return this.shoeBrand !== null && ['Brooks', 'Nike', 'adidas', 'ASICS', 'New Balance', 'HOKA ONE ONE', 'Mizuno', 'On', 'Saucony', 'Altra'].includes(this.shoeBrand);
    },
    shoeWidths() {
      return this.menOrWomenShoeSize === "Men's" ? this.mensShoeWidths : this.womensShoeWidths;
    },
    shoeModels() {
      switch (this.shoeBrand) {
        case 'Brooks':
          return this.brooksModels;
        case 'Nike':
          return this.nikeModels;
        case 'adidas':
          return this.adidasModels;
        case 'ASICS':
          return this.asicsModels;
        case 'New Balance':
          return this.newBalanceModels;
        case 'HOKA ONE ONE':
          return this.hokaModels;
        case 'Mizuno':
          return this.mizunoModels;
        case 'Saucony':
          return this.sauconyModels;
        case 'Altra':
          return this.altraModels;
        case 'On':
          return this.onModels;
        default:
          return [];
      }
    },
  },
  validations: {
    name: {
      required,
    },
  },
  methods: {
    getErrors() {
      const errors = [];
      return errors;
    },
    getSurvey() {
      const ret = {
        question1: this.injuryInLast5Years === 'Yes',
        question2: this.injuryRegions,
        question3: this.yearBorn,
        question4: this.sex,
        question5: this.height,
        question6: this.weight,
        question7: this.menOrWomenShoeSize,
        question8: this.shoeSize,
        question9: this.shoeWidth,
        question10: this.shoeBrand,
        question11: this.shoeModel,
        question12: this.motivation,
        question13: this.contact === 'Yes',
      };
      if (this.injuryOther) {
        ret.question2.push(this.injuryOther);
      }
      if (this.modelText) {
        ret.question11 = this.modelText;
      }
      return ret;
    },
    // this won't work right now because it has a hardcoded non-existent coupon
    async completeSurvey() {
      this.loading = true;
      this.error = null;
      try {
        const result = await this.$store.dispatch('register', {
          email: this.email,
          password: this.password,
          coupon: this.coupon,
        });

        if (this.teamId) {
          const member = await this.$container.dao.addMemberToTeam(
            result.member.member_id, this.teamId,
          );
          await this.$container.memberService.updateMember(member.data, false);
        }
        await this.$store.dispatch('loadData');
        this.$container.analytics.trackRegistration(this.$store.state.user.memberId);
        this.$router.push({ name: 'setup' });
      } catch (error) {
        this.handle_signup_error(error);
      } finally {
        this.loading = false;
      }
    },
    handle_signup_error(error) {
      if (error.response && error.response.data) {
        this.error = error.response.data;
      } else {
        this.error = error;
      }
    },
  },
};
